import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Secure from './Secure'
import { actions } from '../../store'

const mapStateToProps = state => ({
  user: state.user,
  auth: state.auth
})

const mapDispatchToProps = dispatch => bindActionCreators({
  authorizeAdmin: actions.auth.authorizeAdmin,
  getUser: actions.user.getUser
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Secure)



// WEBPACK FOOTER //
// ./src/views/Secure/index.js